import React from 'react';
import ModalAlert from '../modal/modal_alert';
import ModalLoader from '../modal/modal_loader';
import axios from '../axios';

const GenerateOutline = () => {
  const errorModalRef = React.useRef();
  const rateLimitModalRef = React.useRef();
  const loaderRef = React.useRef();

  const [theme, setTheme] = React.useState('');
  const [chatgptUsageLogId, setChatgptUsageLogId] = React.useState('');
  const [eventTitle, setEventTitle] = React.useState('');
  const [eventBody, setEventBody] = React.useState('');
  const [circles, setCircles] = React.useState([]);
  const [circleId, setCircleId] = React.useState(null);

  React.useEffect(() => {
    axios.get('/api/event/generate_outline_circles').then((res) => {
      const data = res.data;
      if (data) {
        setCircles(data.filter((circle) => !!circle[1]));
      }
    });
  }, [setCircles]);

  const isValid = theme.length > 0;
  const outline =
    'タイトル：\n' + eventTitle + '\n\n' + '説明文：\n' + eventBody;

  const generate = () => {
    try {
      loaderRef.current.openModal();
      const response = fetch('/api/event/generate_outline', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ generate: { theme } }),
      }).then((response) => {
        if (!response.ok) {
          loaderRef.current.closeModal();
          if (response.status === 429) {
            rateLimitModalRef.current.openModal();
          } else {
            errorModalRef.current.openModal();
          }
          return;
        }

        response.json().then((json) => {
          setChatgptUsageLogId(json.chatgpt_usage_log_id || '');
          setEventTitle(json.result.title || '');
          setEventBody(json.result.body || '');

          loaderRef.current.closeModal();
        });
      });
    } catch (err) {
      loaderRef.current.closeModal();
      errorModalRef.current.openModal();
    }
  };

  return (
    <React.Fragment>
      <div className="container col-md-8 col-lg-6 pb-5">
        <div className="row justify-content-between p-3_5">
          <label htmlFor="generate-outline-theme">やりたいことを書こう</label>
          <textarea
            name="theme"
            id="generate-outline-theme"
            className="form-control"
            style={{ height: 80 }}
            maxLength={100}
            value={theme}
            onChange={(e) => setTheme(e.target.value)}
            placeholder="鎌倉に小旅行に行って食べ歩きしたい"
          ></textarea>
          <button
            type="button"
            className="a-button a-button__top a-button--orange my-4 w-50"
            disabled={!isValid}
            onClick={() => generate()}
          >
            試しにイベント文を作ってもらう
          </button>
        </div>
        <div className="row justify-content-between p-3_5">
          <div
            className="form-control bg-gray"
            style={{ height: 200, overflow: 'auto', whiteSpace: 'pre-wrap' }}
          >
            {outline}
          </div>
        </div>
        <div className="row justify-content-between px-1">
          <div className="col-12 d-flex flex-row justify-content-between align-items-center mb-4">
            <p className="text-fz-small text-fw-normal text-black-50 mb-0">
              出力結果を使ってイベントを作ってみませんか？
              <br />
              まだサークルを作っていない人は、まず
              <a href="/circles/new">サークルを作ろう</a>！
            </p>
          </div>
        </div>
        <p className="text-fz-small text-fw-normal text-black-50 mb-0">
          サークルのイベントとして作成する
        </p>
        {circles.map((circle) => (
          <React.Fragment key={circle[0]}>
            <input
              type="radio"
              id={circle[0]}
              name="generateEventOutlineCreateEventCircleId"
              onChange={() => setCircleId(circle[0])}
            />
            <label
              htmlFor={circle[0]}
              class="text-fz-small text-fw-normal text-black-50 ml-2"
            >
              {circle[1]}
            </label>
            <br />
          </React.Fragment>
        ))}
        <div className="pb-5">
          <button
            id="generateEventOutlineCreatEvent"
            type="button"
            className="a-button a-button--sm a-button--orange my-4"
            style={{ borderRadius: '4px' }}
            disabled={circleId === null || chatgptUsageLogId.length === 0}
            onClick={() => {
              window.location.href = `/events/new/${circleId}?chatgpt_usage_log_id=${chatgptUsageLogId}`;
            }}
          >
            サークルのイベントを作る
          </button>
        </div>
      </div>
      <ModalAlert
        ref={errorModalRef}
        id="modal-generated-error"
        title="自動生成失敗"
        content="タイトルと説明の自動生成に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalAlert
        ref={rateLimitModalRef}
        id="modal-rate-limit-error"
        title="自動生成失敗"
        content="1日の利用数を超過しました。24時間後にもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} message="約1分お待ちください" dummyProgressShown />
    </React.Fragment>
  );
};

export default GenerateOutline;
